export const GET_ACCOUNT_STATEMENTS_BY_CLIENT_ID = `
	query getAccountStatementsByClientId($clientId: String!) {
		getAccountStatementsByClientId(clientId: $clientId) {
			id
			clientId
			clientName
			createdAt
			period
			endDate
			startDate
			dueDate
			updatedAt
			accountBalance {
				saldoInicial
				incrementoCredito
				creditoTotal
				montoTotalPI
				creditoUtilizado
				montoPagar
				saldoFinal
			}
		}
	}
`;

export const GET_ANTICIPOS_BY_PERIOD_AND_CLIENT_ID = `
	query getAllAnticiposByPeriodAndClientId($period: String!, $clientId: String!) {
		getAllAnticiposByPeriodAndClientId(period: $period, clientId: $clientId) {
			id
			monto
			descripcion
			createdAt
		}
	}
`;
